import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';

import { PreLoadGuard } from './core/guards/preload.guard';
import { FailedComponent } from './failed/failed.component';
import { LandingComponent } from './modules/landing/landing.component';
import { CalculatorComponent } from './modules/calculator/calculator.component';
import { ContractsComponent } from './modules/contracts/contracts.component';
import { ProfileComponent } from './modules/profile/profile.component';
import { ClientContractComponent } from './modules/client-contract/client-contract.component';
import { SuperGuaranteeComponent } from './modules/super-guarantee/super-guarantee.component';
import { RoleGuard } from './core/guards/role.guard';
import { BerriaGuard } from './core/guards/berria.guard';

export const routes: Routes = [
  // parte privada
  {
    path: '',
    canActivate: [MsalGuard],
    canActivateChild: [PreLoadGuard],
    children: [
      //TODO: DE MANERA TEMPORAL USAREMOS EL BERRIA GUARD PARA REDIRECCIONAR A UNA PANTALLA DE INICIO U A OTRA DEPENDIENDO DE SI 
      // EL USUSARIO TIENE EL ROL DE BERRIA. PARA FUTURAS IMPLEMENTACIONES SE HA PROPUESTO AGREGAR UNA PÁGINA DE WELCOME.
      {
        path: '',
        component: ProfileComponent,
        canActivate: [BerriaGuard], 
      },
      {
        title: "Calculadora",
        path: 'calculator',
        component: CalculatorComponent,
        canActivate: [RoleGuard],
        data: { 
          roles: [
            "espdvsales.contributor"
          ] 
        }
      },
      {
        title: "Berria Care",
        path: 'berriaCare',        
        component: SuperGuaranteeComponent,
        canActivate: [RoleGuard],
        data: { 
          roles: [
            "espdvsales.berria"
          ] 
        }
      },
      {        
        path: 'clientData',
        component: ClientContractComponent,
        canActivate: [RoleGuard],
        data: { 
          roles: [
            "espdvsales.contributor",
            "espdvsales.berria",
          ] 
        }
      },
      {
        title: "Perfil",
        path: 'profile',
        component: ProfileComponent,
        canActivate: [RoleGuard],
        data: { 
          roles: [
            "espdvsales.contributor",
            "espdvsales.berria"
          ] 
        }
      },
      {
        title: 'Contratos',
        path: 'contract',
        component: ContractsComponent,
        canActivate: [RoleGuard],
        data: { 
          roles: [
            "espdvsales.contributor",
            "espdvsales.berria"
          ] 
        }
      },
    ],
  },
  {
    path: 'login-failed',
    component: FailedComponent,
  },
  {
    // Needed for handling redirect after login
    path: 'auth',
    component: MsalRedirectComponent,
  },
  // parte publica
  {
    path: 'landing/:uid',
    component: LandingComponent,
  },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled', // Don't perform initial navigation in iframes
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
